import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOrderNote } from '~/types/note/models'

export const {
  getNoteListData: getOrderNoteListData,
  getNoteDataById: getOrderNoteDataById,
  getNoteListDataByParentId: getOrderNoteListDataByOrderId,
} = makeNoteMockData<IOrderNote>({
  entityName: 'order',
  storageKeyPrefix: 'order',
})
